export const figure11 = {
	chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '1000px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
      colors: ['#ed7d31'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      exporting: {
        enabled: false
      },

  xAxis: {
      categories: [
	   "Sénégal 2019",
	   "Niger 2014",
	   "Guinée-Bissau 2019",
	   "Malawi 2020",
	   "Ouganda 2016",
	   "Burkina Faso 2019",
	   "Inde 2012",
	   "République-Unie de Tanzanie 2015",
	   "Éthiopie 2019",
	   "Mali 2017",
	   "Bénin 2019",
	   "Nigéria 2019",
	   "Togo 2019",
	   "Géorgie 2020",
	   "Grèce 2016",
	   "Finlande 2016",
	   "Lituanie 2016",
	   "Roumanie 2016",
	   "Slovénie 2016",
	   "Autriche 2016",
	   "Slovaquie 2016",
	   "Cambodge 2019",
	   "Lettonie 2016",
	   "Luxembourg 2016",
	   "Allemagne 2016",
	   "Estonie 2016",
	   "Tchéquie 2016",
	   "Pologne 2016",
	   "Croatie 2016",
	   "Portugal 2016",
	   "Suède 2016",
	   "Hongrie 2016",
	   "Irlande 2016",
	   "Espagne 2016",
	   "Bulgarie 2016",
	   "France 2016",
	   "Malte 2016",
	   "Belgique 2016",
	   "Chypre 2016",
	   "Italie 2016",
	   "Danemark 2016",
	   "Canada 2016",
	   "Pays-Bas 2016"
      ],
      title: {
          text: null
      }
  },
  yAxis: {
      min: 0,
      max: 1.4,
      tickInterval: 0.2,
      title: {
          text: null,
      },
      labels: {
		          overflow: 'justify'
      }
  },
  plotOptions: {
      bar: {
          dataLabels: {
              enabled: true
          }
      }
  },
  legend: {
      enabled: false,
  },
  series: [{
      name: 'Proportion de femmes parmi les propriétaires fonciers',
      data: [1.27, 0.90, 0.90, 0.88, 0.78, 0.68, 0.68, 0.66, 0.62, 0.62, 0.60, 0.58, 0.57, 0.32, 0.30, 0.27, 0.25, 0.19, 0.19, 0.19, 0.19, 0.17, 0.13, 0.12, 0.12, 0.12, 0.11, 0.10, 0.10, 0.10, 0.09, 0.09, 0.08, 0.08, 0.08, 0.08, 0.08, 0.07, 0.06, 0.06, 0.05, 0.05, 0.04 ] ,
  }]
}